import Typography from "@mui/material/Typography";
import { FC, PropsWithChildren } from "react";
import PrimaryButton, {
  PrimaryButtonProps,
} from "shared/components/PrimaryButton";
import { COLOR_BLACK } from "shared/theme/colors";
import { StyledButtonsContainer, StyledContainer, StyledModal } from "./styled";

type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
  secondaryButtonTitle: string;
  onSecondaryClick: () => void;
  primaryButtonTitle: string;
  onPrimaryClick: () => void;
  primaryColor: PrimaryButtonProps["color"];
  isSubmitting?: boolean;
  isDisabled?: boolean;
  footerStyles?: React.CSSProperties;
};

const Modal: FC<PropsWithChildren<Props>> = (props) => {
  return (
    <StyledModal open={props.open} onClose={props.onClose}>
      <StyledContainer>
        <Typography variant="heading3" fontWeight={700} color={COLOR_BLACK}>
          {props.title}
        </Typography>
        {props.children}
        <StyledButtonsContainer style={props.footerStyles}>
          <PrimaryButton
            title={props.secondaryButtonTitle}
            onClick={props.onSecondaryClick}
            color="secondary"
            variant="outlined"
            size="small"
            rounded={false}
          />
          <PrimaryButton
            title={props.primaryButtonTitle}
            onClick={props.onPrimaryClick}
            color={props.primaryColor}
            size="small"
            rounded={false}
            loading={props.isSubmitting}
            disabled={props.isDisabled}
          />
        </StyledButtonsContainer>
      </StyledContainer>
    </StyledModal>
  );
};

export default Modal;
